// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropzone {
  height: auto;
  min-height: 6rem;
  border: 2px dashed #0070f3;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: #f9f9f9;
  transition: border-color 0.3s ease;
  padding: 20px;
  position: relative;
}

.dropzone:hover {
  border-color: #0a58ca;
}

.preview-container {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  justify-content: center;
  gap: 10px;
}

.preview-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 5px;
}

.preview-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 5px;
}

.preview-video {
  width: 200px;
  height: 300px;
  object-fit: cover;
  border-radius: 5px;
}

.remove-button {
  margin-top: 5px;
  padding: 5px 10px;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.remove-button:hover {
  background-color: #c82333;
}`, "",{"version":3,"sources":["webpack://./src/components/imageDragAndDrop/style.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EACA,0BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;EACA,kCAAA;EACA,aAAA;EACA,kBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,sCAAA;AACF;;AAEA;EACE,yBAAA;AACF","sourcesContent":[".dropzone {\n  height: auto;\n  min-height:6rem;\n  border: 2px dashed #0070f3;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  background-color: #f9f9f9;\n  transition: border-color 0.3s ease;\n  padding: 20px;\n  position: relative;\n}\n\n.dropzone:hover {\n  border-color: #0a58ca;\n}\n\n.preview-container {\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 10px;\n  justify-content: center;\n  gap: 10px;\n}\n\n.preview-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 5px;\n}\n\n.preview-image {\n  width: 100px;\n  height: 100px;\n  object-fit: cover;\n  border-radius: 5px;\n}\n\n.preview-video {\n  width: 200px;\n  height: 300px;\n  object-fit: cover;\n  border-radius: 5px;\n}\n\n.remove-button {\n  margin-top: 5px;\n  padding: 5px 10px;\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.remove-button:hover {\n  background-color: #c82333;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
